import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

const demoCompany = {
  id: 1,
  name: 'Stolarnia Kowalski',
  address: 'ul. Dębowa 12, 00-001 Warszawa',
  email: 'kontakt@stolarnia-kowalski.pl',
  phoneNumber: '+48 500 100 200',
  logoUrl: '',
  maxUsers: 5,
  maxOrders: 100,
  maxValuations: 100
};

const demoUsers = [
  { id: 1, email: 'admin@plankerp.local', firstName: 'Michał', lastName: 'Kowalski', isActive: true, validFrom: '2026-01-01', validTo: '2027-01-01', roles: ['ADMIN'], company: demoCompany },
  { id: 2, email: 'anna@stolarnia-kowalski.pl', firstName: 'Anna', lastName: 'Krawczyk', isActive: true, validFrom: '2026-02-01', validTo: '2027-01-01', roles: ['MANAGER', 'ORDERS'], company: demoCompany },
  { id: 3, email: 'piotr@stolarnia-kowalski.pl', firstName: 'Piotr', lastName: 'Wiśniewski', isActive: true, validFrom: '2026-03-01', validTo: '2027-01-01', roles: ['ORDERS', 'VALUATIONS'], company: demoCompany },
  { id: 4, email: 'kontakt@nowa-stolarnia.pl', firstName: 'Karolina', lastName: 'Nowak', isActive: false, validFrom: '2025-06-01', validTo: '2026-06-01', roles: ['VALUATIONS'], company: { ...demoCompany, id: 2, name: 'Nowa Stolarnia' } }
];

const demoCompanies = [
  { ...demoCompany, pricesCount: 28, ordersCount: 64, valuationsCount: 41 },
  { ...demoCompany, id: 2, name: 'Nowa Stolarnia', email: 'kontakt@nowa-stolarnia.pl', address: 'ul. Leśna 8, 30-001 Kraków', maxUsers: 3, pricesCount: 11, ordersCount: 22, valuationsCount: 9 }
];

export const mockApiInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  if (!environment.mockApi || !req.url.includes('/api/')) return next(req);

  const path = req.url.split('/api/')[1]?.split('?')[0] ?? '';
  if (path === 'auth' && req.method === 'POST') {
    return of(new HttpResponse({ status: 200, body: { accessToken: 'local-demo-token', refreshToken: 'local-demo-token' } }));
  }
  if (path === 'auth/check-token' || path === 'auth/refresh' || path === 'auth/logout') {
    return of(new HttpResponse({ status: 200, body: path.endsWith('refresh') ? { accessToken: 'local-demo-token', refreshToken: 'local-demo-token' } : {} }));
  }
  if (path === 'admin/users') {
    return of(new HttpResponse({ status: 200, body: pageOf(demoUsers, req.url) }));
  }
  if (path === 'admin/user-roles') {
    return of(new HttpResponse({ status: 200, body: ['ADMIN', 'MANAGER', 'ORDERS', 'VALUATIONS'] }));
  }
  if (path === 'admin/companies') {
    return of(new HttpResponse({ status: 200, body: pageOf(demoCompanies, req.url) }));
  }
  if (path.startsWith('admin/')) {
    return of(new HttpResponse({ status: 200, body: {} }));
  }
  return next(req);
};

function pageOf<T>(content: T[], url: string) {
  const query = new URL(url).searchParams;
  const size = Number(query.get('size') ?? 10);
  const page = Number(query.get('page') ?? 0);
  return { content: content.slice(page * size, (page + 1) * size), totalElements: content.length, totalPages: Math.ceil(content.length / size), number: page, size };
}
